import React from 'react'

import { BrowserRouter, useLocation, useNavigate, useParams } from 'react-router-dom'
import { StaticRouter } from 'react-router-dom/server'

import PropTypes from 'prop-types'

export { useLocation, useNavigate, useParams }

function ContextBasedRouter({ children, initialPathname = '' }) {
  if (typeof window === 'undefined') {
    return (
      <StaticRouter location={initialPathname}>
        {children}
      </StaticRouter>
    )
  }

  return (
    <BrowserRouter>
      {children}
    </BrowserRouter>
  )
}

ContextBasedRouter.propTypes = {
  children: PropTypes.node.isRequired,
  initialPathname: PropTypes.string,
}

export default ContextBasedRouter
